export const WP_ROOT = "https://nsrm.co.uk";
export const HOME = "https://nsrm.co.uk";
export const OAUTH_CLIENT_ID = "3ln4rdknG375NV54BB5buDnntPtDxMFh4iJVRWAc";
export const API_ROOT = "https://api.app.nsrm.co.uk";
export const NODE_ENV = "production";
export const COOKIE_NAME = "nsrm-token";
export const ALGOLIA_APP = "VAZ8Q4VM0X";


